import React, { use, useEffect, useState } from "react";
import { Topbar } from "../../components/include/Topbar";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import camera from "../../assets/camera.svg";
import cameraWhite from "../../assets/camera-white.png";
import { toast } from "sonner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import calender from "../../assets/Icons/calendar.png";
import { isRole, isRoleType } from "../../redux/selectors/authSelector";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const Add_Member = () => {
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const [formData, setFormData] = useState({
    memberName: "",
    designation: "",
    bio: "",
    email: "",
    mobile: "",
    country: "KE",
    description: "",
    startDate: "",
    endDate: "",
    socialLinks: [],
    profilePicture: null,
  });

  const dialCodes = {
    KE: "+254",
    UG: "+256",
  };
  const flagsContext = require.context(
    "../../assets/flags",
    false,
    /\.(png|jpe?g|svg)$/
  );
  const getFlagImage = (code) => {
    try {
      return flagsContext(`./${code.toLowerCase()}.png`);
    } catch (e) {
      return null;
    }
  };
  const [apiloader, setapiloader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [linkInput, setLinkInput] = useState("");
  const [errors, setErrors] = useState({});
  const [socialError, setSocialError] = useState("");
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);
  const [newLink, setNewLink] = useState("");
  const [previewURL, setPreviewURL] = useState(null);
  const [file, setFile] = useState(false);
  const schoolId = localStorage.getItem("activeSchoolId");
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const mode = localStorage.getItem("mode");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  async function fetchData(id) {
    const response = await Postdata(HttpService.teacher_management_show, {
      id,
    });

    if (response.status !== 200) {
      if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
        navigate("navigation-dashboard", {
          state: { mainTab: "Teacher Management" },
        });
      } else {
        navigate("teacher-management");
      }
    }

    const data = response.data;

    // Formatting the startDate and endDate as per the format you mentioned
    const formattedStartDate = data.start_date
      ? dayjs(data.start_date).format("DD MMM YYYY")
      : "";
    const formattedEndDate =
      data.end_date !== "Ongoing" && data.end_date
        ? dayjs(data.end_date).format("DD MMM YYYY")
        : data.end_date;

    // Parse country code from mobile
    let country = "KE";
    let mobileNum = data.mobile || "";
    if (mobileNum.startsWith("+254")) { country = "KE"; mobileNum = mobileNum.replace("+254", ""); }
    else if (mobileNum.startsWith("+256")) { country = "UG"; mobileNum = mobileNum.replace("+256", ""); }

    setFormData({
      memberName: data.name || "",
      designation: data.designation || "",
      bio: data.bio || "",
      email: data.email || "",
      mobile: mobileNum,
      country: country,
      description: data.description || "",
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      socialLinks: data.social_media || [],
      id: params.id,
    });

    setPreviewURL(data.profile_img || null);
    setapiloader(false);
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Allowed formats
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      // dispatch(message("Only JPG, JPEG, PNG, or WEBP formats are allowed"));
      toast.warning("Only JPG, JPEG, PNG, or WEBP formats are allowed");

      return;
    }

    // Size check (10MB)
    if (file.size > 5 * 1024 * 1024) {
      // dispatch(message("Image size must be less than 10MB"));
      toast.warning("Image size must not exceed 5MB");

      return;
    }

    setFile(true);
    setFormData((prev) => ({ ...prev, profilePicture: file }));
    setPreviewURL(URL.createObjectURL(file));
  };

  const handleAddLink = () => {
    // Regex pattern for validating URLs of popular social media sites
    const socialMediaPattern =
      /^(https?:\/\/)?(www\.)?(facebook\.com|twitter\.com|instagram\.com|linkedin\.com|youtube\.com|tiktok\.com)\/[^\s]+$/;

    // Check if the link is a valid social media URL
    if (!socialMediaPattern.test(linkInput.trim())) {
      setSocialError(
        "Please enter a valid social media URL (e.g., https://facebook.com/username)"
      );
      return;
    }

    if (linkInput.trim() === "") {
      setSocialError("URL cannot be empty");
      return;
    }

    // Clear any existing error message when link is valid
    setSocialError("");

    setFormData({
      ...formData,
      socialLinks: [...formData.socialLinks, linkInput],
    });
    setLinkInput(""); // Clear input field after adding
  };

  const handleRemoveLink = (index) => {
    const newLinks = formData.socialLinks.filter((_, i) => i !== index);
    setFormData({ ...formData, socialLinks: newLinks });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (
      (name === "memberName" || name === "designation") &&
      !/^[A-Za-z ]*$/.test(value)
    ) {
      return;
    }
    if (name === "mobile" && !/^[0-9]*$/.test(value)) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.memberName) newErrors.memberName = true;
    if (!formData.designation) newErrors.designation = true;
    if (!formData.bio) newErrors.bio = true;
    if (!formData.description) newErrors.description = true;
    if (!formData.startDate) newErrors.startDate = "Start Date is Required";
    // if (!formData.endDate) newErrors.endDate = true;
    // if (!formData.profilePicture) newErrors.profilePicture = true;
    // if (formData.socialLinks.length === 0) newErrors.socialLinks = true;
    // Image required check
    if (!params.id && !formData.profilePicture) {
      newErrors.profilePicture = true; // Adding new, must have image
    }
    if (params.id && !formData.profilePicture && !previewURL) {
      newErrors.profilePicture = true; // Editing but no existing image
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = () => {
  //   if (!validate()) return;
  //   if (formData.startDate) {
  //     console.log("formData.endDate: ", formData.endDate);
  //     console.log("formData.startDate: ", formData.startDate);

  //     const startDate = new Date(formData.startDate);

  //     if (formData.endDate) {
  //       // Only check if endDate is provided
  //       const endDate = new Date(formData.endDate);

  //       if (endDate < startDate) {
  //         setErrors({ endDate: "End Date cannot be before Start Date" });
  //         return;
  //       }
  //     }
  //   }

  //   // setLoader(true);

  //   const form = new FormData();
  //   if (params.id) form.append("id", formData.id);
  //   form.append("name", formData.memberName);
  //   form.append("designation", formData.designation);
  //   form.append("bio", formData.bio);
  //   form.append("description", formData.description);
  //   form.append("start_date", formData.startDate);
  //   form.append("end_date", formData.endDate || "");
  //   form.append("school_id", schoolId);
  //   if (file) form.append("profile_img", formData.profilePicture); // binary file
  //   formData.socialLinks.forEach((link, i) =>
  //     form.append(`social_media[${i}]`, link)
  //   );

  //   Postdata(HttpService.teacher_management_add, form).then((res) => {
  //     if (res.status === 200) {
  //       toast.success(res.message);
  //       if (role === "admin") {
  //         if (mode === "view") {
  //           navigate(`admin-school/view/${schoolId}`, {
  //             state: { mainTab: "Teacher Management" },
  //           });
  //         } else {
  //           navigate("navigation-dashboard", {
  //             state: { mainTab: "Teacher Management"},
  //           });
  //         }
  //       } else {
  //         navigate("teacher-management");
  //       }
  //     }
  //     // dispatch(message(res.message));
  //   });
  //   // setLoader(false);

  //   console.log("Submitted as FormData:", formData);
  // };

  const handleSubmit = async () => {
    if (loader) return;
    if (!validate()) return;

    if (formData.startDate) {
      const startDate = new Date(formData.startDate);
      if (formData.endDate) {
        const endDate = new Date(formData.endDate);
        if (endDate < startDate) {
          setErrors({ endDate: "End Date cannot be before Start Date" });
          return;
        }
      }
    }

    setLoader(true);

    try {
      const form = new FormData();

      if (params.id) form.append("id", formData.id);
      form.append("name", formData.memberName);
      form.append("designation", formData.designation);
      form.append("bio", formData.bio);
      form.append("email", formData.email);
      form.append("mobile", dialCodes[formData.country] + formData.mobile);
      form.append("description", formData.description);
      form.append("start_date", formData.startDate);
      form.append("end_date", formData.endDate || "");
      form.append("school_id", schoolId);

      if (file) {
        form.append("profile_img", formData.profilePicture);
      }

      formData.socialLinks.forEach((link, i) =>
        form.append(`social_media[${i}]`, link)
      );

      const res = await Postdata(HttpService.teacher_management_add, form);

      if (res.status === 200) {
        toast.success(res.message);

        if (role === "admin" || role === "subadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Teacher Management" },
            });
          } else {
            navigate("navigation-dashboard", {
              state: { mainTab: "Teacher Management" },
            });
          }
        } else {
          navigate("teacher-management");
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (params.id) {
      setapiloader(true);
      fetchData(params.id);
    }
  }, []);

  console.log(location.state?.type, "++++++++++++");

  return (
    <>
      <Topbar
        title={
          location.state?.type === "edit"
            ? "Edit Teacher Management"
            : "Add Teacher Management"
        }
        aerrow={true}
      />
      <div className="max-w-6xl  mx-auto bg-gray-100 p-6 rounded-xl space-y-6">
        {/* Profile Picture */}
        <div className="flex flex-col items-center">
          <label className="flex flex-col items-center justify-center w-24 h-24 rounded-full border-2 border-purple-500 cursor-pointer overflow-hidden">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
            />
            <div className="relative w-full h-full flex justify-center items-center">
              {previewURL ? (
                <div className="relative w-full h-full">
                  {/* Preview Image with Darkened Effect */}
                  <img
                    src={previewURL}
                    alt="Preview"
                    className="w-full h-full object-cover rounded-full filter brightness-75"
                  />
                  {/* Camera Icon on Top of Preview Image */}
                  <img
                    src={cameraWhite}
                    alt="Camera Icon"
                    className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-5 h-5"
                  />
                </div>
              ) : (
                // Camera Icon when no preview is available
                <img
                  src={camera}
                  alt="Camera Icon"
                  className="w-5 h-5 text-gray-500 "
                />
              )}
            </div>
          </label>
          <span className="text-sm mt-2 text-gray-700 font-medium">
            Upload Profile Picture <span className="text-red-500">*</span>
          </span>
          {errors.profilePicture && (
            <span className="text-red-500 text-sm">
              Profile picture is required
            </span>
          )}
        </div>

        {/* Inputs */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Member Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="memberName"
              placeholder="Enter Member Name"
              className="input-field"
              value={formData.memberName}
              onChange={handleInputChange}
              maxLength={30}
            />
            {errors.memberName && (
              <span className="text-red-500 text-sm">
                Member Name is Required
              </span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Designation <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="designation"
              placeholder="Enter Designation"
              className="input-field"
              value={formData.designation}
              onChange={handleInputChange}
              maxLength={30}
            />
            {errors.designation && (
              <span className="text-red-500 text-sm">
                Designation is Required
              </span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Bio <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="bio"
              placeholder="Write Bio"
              className="input-field"
              value={formData.bio}
              onChange={handleInputChange}
              maxLength={50}
            />
            {errors.bio && (
              <span className="text-red-500 text-sm">Bio is Required</span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter Email"
              className="input-field"
              value={formData.email}
              onChange={handleInputChange}
              maxLength={50}
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Mobile Number
            </label>
            <div className="flex items-center border border-gray-300 rounded-xl px-2 py-2 gap-2 bg-white">
              <div className="relative flex items-center cursor-pointer">
                <select
                  value={formData.country}
                  onChange={(e) =>
                    setFormData({ ...formData, country: e.target.value })
                  }
                  className="absolute inset-0 opacity-0 cursor-pointer"
                >
                  <option value="KE">Kenya</option>
                  <option value="UG">Uganda</option>
                </select>
                <img
                  src={getFlagImage(formData.country)}
                  alt="flag"
                  className="w-6 h-4"
                />
                <span className="ml-1 text-xs">▾</span>
              </div>
              <input
                type="tel"
                value={formData.mobile}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  setFormData({ ...formData, mobile: onlyNumbers });
                }}
                maxLength={10}
                placeholder="Enter Mobile Number"
                className="flex-1 outline-none border-0 focus:ring-0"
              />
            </div>
          </div>
        </div>

        {/* Description */}
        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            name="description"
            placeholder="Write here"
            className="input-field"
            value={formData.description}
            onChange={handleInputChange}
            maxLength={1000}
          />
          {errors.description && (
            <span className="text-red-500 text-sm">
              Description is Required
            </span>
          )}
        </div>

        {/* Social Media Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div className="relative">
            <label className="block mb-1 font-medium text-gray-700">
              Social Media Links
              {/* <span className="text-red-500">*</span> */}
            </label>
            <input
              type="text"
              placeholder="Enter Social Media Link"
              className="input-field"
              value={linkInput}
              onChange={(e) => setLinkInput(e.target.value)}
              pattern="https?://.*"
              title="Please enter a valid URL (e.g., http://example.com)"
            />
            <button
              type="button"
              onClick={handleAddLink}
              className="text-orange-600 font-medium absolute right-3 top-[50px]"
            >
              Add
            </button>

            {/* {errors.socialLinks && (
              <span className="text-red-500 text-sm block">Social Media Links is Required</span>
            )} */}
            {socialError && (
              <span className="text-red-500 text-sm">{socialError}</span>
            )}

            <div className="mt-2 space-y-1">
              {formData.socialLinks.map((link, index) => (
                <div key={index} className="flex items-center justify-between">
                  <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline text-sm"
                  >
                    {link}
                  </a>
                  <button
                    onClick={() => handleRemoveLink(index)}
                    className="text-red-600 text-sm"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* <div>
            <label className="block mb-1 font-medium text-gray-700">
              Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="startDate"
              className="input-field"
              value={formData.startDate}
              onChange={handleInputChange}
              min="1900-01-01"
              max="9999-12-31"
            />
            {errors.startDate && <span className="text-red-500 text-sm">{errors.startDate}</span>}
          </div> */}

          {/* <div>
            <label className="block mb-1 font-medium text-gray-700">
              End Date
            </label>
            <input
              type="date"
              name="endDate"
              className="input-field"
              value={formData.endDate}
              onChange={handleInputChange}
              min={formData.startDate && "1900-01-01"}
              max="9999-12-31"
            /> */}
          {/* {errors.endDate && ( typeof errors.endDate === 'string' ? <span className="text-red-500 text-sm">{errors.endDate}</span> :
                <span className="text-red-500 text-sm">End Date is Required</span>
            )} */}
          {/* </div> */}

          {/* Start Date */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Start Date <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <DatePicker
                selected={formData.startDate}
                onChange={(date) =>
                  setFormData({ ...formData, startDate: date })
                }
                dateFormat="dd/MM/yyyy"
                className="w-full md:w-[215px] xl:w-[350px] p-3 rounded-xl pr-10"
                placeholderText="dd/mm/yyyy"
                minDate={new Date("1900-01-01")}
                maxDate={new Date("9999-12-31")}
                onChangeRaw={(e) => e.preventDefault()}
                autoComplete="off"
              />
              <img
                src={calender}
                alt="Calendar Icon"
                className="absolute right-4 top-1/2 -translate-y-1/2 h-[0.8em] w-[0.8em] md:h-[1em] md:w-[1em] xl:h-[1.2em] xl:w-[1.2em] pointer-events-none"
              />
            </div>
            {errors.startDate && (
              <p className="text-red-500 text-sm">{errors.startDate}</p>
            )}
          </div>

          {/* End Date */}
          <div className="">
            <label className="block mb-1 font-medium text-gray-700">
              End Date
            </label>
            <div className="relative">
              <DatePicker
                selected={formData.endDate}
                onChange={(date) => setFormData({ ...formData, endDate: date })}
                dateFormat="dd/MM/yyyy"
                className="w-full md:w-[215px] xl:w-[350px] p-3 rounded-xl pr-10"
                placeholderText="dd/mm/yyyy"
                minDate={formData.startDate || new Date("1900-01-01")} // ✅ cannot select end date before start date
                maxDate={new Date("9999-12-31")}
                onChangeRaw={(e) => e.preventDefault()}
                autoComplete="off"
              />
              <img
                src={calender}
                alt="Calendar Icon"
                className="absolute right-4 top-1/2 -translate-y-1/2 h-[0.8em] w-[0.8em] md:h-[1em] md:w-[1em] xl:h-[1.2em] xl:w-[1.2em] pointer-events-none"
              />
            </div>

            {errors.endDate &&
              (typeof errors.endDate === "string" ? (
                <p className="text-red-500 text-sm">{errors.endDate}</p>
              ) : (
                <p className="text-red-500 text-sm">End Date is Required</p>
              ))}
          </div>
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button
            onClick={handleSubmit}
            disabled={loader}
            className={`bg-primary_main text-white px-24 py-3 rounded-lg font-medium
    ${loader ? "opacity-60 cursor-not-allowed" : "hover:bg-purple-700"}`}
          >
            {loader ? "Please wait..." : formData.id ? "Save" : "Add Member"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Add_Member;
